import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { MailService } from '../service/mail.service';
import { AdminshareService } from "../service/adminshare.service";
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

// ngAfterViewChecked を利用するための import
import { AfterViewChecked } from '@angular/core';
// 子コンポーネントの参照をリストで取得するための import
import { ViewChildren, QueryList } from '@angular/core';
// 子コンポーネントを import
import { ACompanyListComponent } from './a-company-list.component';
import { MailTaskCreateComponent } from './a-mailtask-create.component';

import { NgbDateStruct, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ATemplateSaveModalComponent } from './a-template-save-modal.component';
import { AViewTextModalComponent } from './a-view-text-modal.component';
import { ATaskShowModalComponent } from './a-mailtask-show-modal.component';

@Component({
    selector: 'mail-app',
    templateUrl: './mail.component.html',
    styleUrls: ['mail.component.css']
})
export class MailComponent implements AfterViewChecked {

    @Input() event_id: number;
    title : string = 'メール配信';

    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 20;   /* 最大表示件数 */

    isLoaded : boolean = false;
    selected : boolean = false;
    datalist : any = [];
    all_datalist: any = [];
    template : any = [];
    mail_from : any = [];
    mendan_flg : any;
    online_flg : any;
    company_id : any;

    person_search_text:string="";
    syozoku_search_text:string="";

    person_list : any=[];
    syozoku_list : any=[];
    send_list_company:any=[];
    send_list_syozoku:any=[];    
    send_list_person:any=[];    
    event:any=[];
    company_list:any=[];
    status_list : any = [];
    status_list_default : any = [];
    yoyaku_status_list : any = [];
    yoyaku_status_list_default : any = [];
    slist:any =[];
    ylist:any =[];
    syozoku_temp_list:any=[];
    langList:any=[];
    yoyakuhyoList:any=[];
    historyMode: number = 0;
    taskType:any=[];

    selected_event_id : number = null;
    public selected_company_id : number = null;

    mail_open:boolean = false;
    hint_show:boolean = false;
    file_show:boolean = false;
    tabActiveId:string = "company";
    ROLE: any = Role;
    mail_content:any ={
        m_mail_template_id:null,
        m_mail_template_name:'',
        mail_subject:'',
        mail_body:'',
        mail_from:'',
        update_datetime:null
    }
    send_mail_file:any=[];
    file_size_before:number;
    file_size_after:number;
    sum_file_size:any;
    over_size:boolean = false;

    monsin_flg:any = null;
    yoyaku_flg:any = null; 
   /**
   * 子コンポーネントの参照から値をセットするためのプロパティ
   *
   * @type {String}
   * @memberof ViewChildComponent
   */
  public valueBox: String[] = ['', '', ''];
    /**
   * 子コンポーネントの参照
   * テンプレートで指定した子コンポーネントをリストで取得できる
   *
   * @type {ViewChildComponent}
   * @memberof ViewParentComponent
   */
  @ViewChildren(ACompanyListComponent) viewChildren: QueryList<ACompanyListComponent>;

    constructor(
        private commonService: CommonService,
        private mailService: MailService,
        private adminShareService: AdminshareService,
        public usersService: UsersService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }

    /**
   * ビューの変更をフックする
   *
   * @memberof ViewParentComponent
   */
  ngAfterViewChecked() {

    this.viewChildren.forEach((item, index) => {
      if (this.selected_company_id !== item.selected_id) {

        // ERROR Error: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked
        // の回避のために遅延評価を行う
        setTimeout(() => {
          this.selected_company_id = item.selected_id;
        }, 0);
      }
    });
  }
    ngOnInit(): void {
        this.selected_event_id = +this.route.snapshot.paramMap.get('eid');
        this.getList();
      };

    clearData (): void{
        this.isLoaded = false;
        this.datalist = [];
        this.template = [];
        this.send_mail_file = [];
    }
    clearSendArea (): void{
        this.person_search_text="";
        this.syozoku_search_text="";
        this.person_list = [];
        this.syozoku_list = [];
        this.send_list_company=[];
        this.send_list_syozoku=[];
        this.send_list_person=[];
        this.status_list = this.status_list_default;
        this.send_mail_file = [];
    }
    clearMailContents (): void{
        this.mail_content.m_mail_template_id = null;
        this.mail_content.m_mail_template_name='';
        this.mail_content.mail_subject = '';
        this.mail_content.mail_body = '';
        this.mail_content.update_datetime = null;
        this.mail_content.m_event_task_type_id = null;
    }

    getList(): void {
        this.clearData();
        let param ={
            eid:this.selected_event_id,
            page:this.page,
            display_per_page:this.display_per_page
        };
        this.mailService.getMailList(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.event= res["fuel_results"]['event'];
                if (this.event.length==0){
                //対象のイベントがないメッセージを表示し、イベント一覧画面へ飛ばす
                this.commonService.modalOpens(11007,modalresult=>{
                    this.router.navigate(["/event"]);
                    });
                }
                this.company_id = res["fuel_results"]['contract_company_id'];
                this.historyMode = 0;
                this.all_count = res["fuel_results"]["all_count"];
                this.all_datalist[0] = res["fuel_results"]["history"];
                //タスク用の履歴
                this.all_datalist[1] = res["fuel_results"]['history_task'];
                this.changePage(1);

                this.company_list= res["fuel_results"]['company'];
                this.template= res["fuel_results"]['template'];
                this.status_list= res["fuel_results"]['answerstatus'];
                for (let i = 0; i < this.status_list.length; i++) {
                    this.status_list[i]['selected'] = this.commonService.exchange01toTF(this.status_list[i]['selected']);
                }
                this.yoyaku_status_list= res["fuel_results"]['yoyakustatus'];
                for (let i = 0; i < this.yoyaku_status_list.length; i++) {
                    this.yoyaku_status_list[i]['selected'] = this.commonService.exchange01toTF(this.yoyaku_status_list[i]['selected']);
                }
                //回答状況のデフォルト値を退避
                this.status_list_default = JSON.parse(JSON.stringify(this.status_list));
                //予約状況のデフォルト値を退避
                this.yoyaku_status_list_default = JSON.parse(JSON.stringify(this.yoyaku_status_list));
                //予約関連の置換を行う際に使用できる言語のリストを取得
                this.langList = res["fuel_results"]['yoyaku_replacement'];
                this.yoyakuhyoList = res["fuel_results"]['yoyakuhyo_replacement'];
                this.taskType = res["fuel_results"]['task_type'];
                this.mail_from= res["fuel_results"]['mail_from'];
                this.monsin_flg=  res["fuel_results"]['monsin_flg'];
                this.yoyaku_flg = res["fuel_results"]['yoyaku_flg'];
                this.mendan_flg = res["fuel_results"]['mendan_flg'];
                //不具合暫定対応 online_flg=0に
                this.online_flg = 0;

                if(this.monsin_flg==0){
                    for(let i = 0; i < this.status_list.length; i++){
                        this.status_list[i]['selected'] == false;
                    }
                }
                if(this.yoyaku_flg==0){
                    for(let i = 0; i < this.yoyaku_status_list.length; i++){
                        this.yoyaku_status_list[i]['selected'] == false;
                    }
                }

                this.isLoaded = true;

                //temp_send_listがある場合
                if ( this.adminShareService.temp_send_list.length > 0 ){
                    if (this.adminShareService.from_page == "person"){
                        this.tabActiveId = 'person';
                        this.send_list_person=this.adminShareService.temp_send_list;
                        this.mail_open = true;            
                    }else if (this.adminShareService.from_page == "syozoku"){
                        this.tabActiveId = 'syozoku';
                            for (let i = 0; i < this.adminShareService.temp_send_list.length; i++) {
                                    this.syozoku_temp_list.push(this.adminShareService.temp_send_list[i]['t_syozoku_id']);
                            }
                        this.mailService.getSyozokuMailList(this.syozoku_temp_list)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.send_list_syozoku=res["fuel_results"]['syozoku'];
                                this.mail_open = true;            
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                    }
        
                }else{
                    this.mail_open = false;            
                }
        
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    changePage(e){
        var start = (e-1)*this.display_per_page;
        this.datalist = this.all_datalist[this.historyMode].slice(start, start+this.display_per_page);
    }
    getAnswerStatusList(){
        this.slist = [];
        for (let i = 0; i < this.status_list.length; i++) {
            if(this.status_list[i]['selected']){
                this.slist.push(this.status_list[i]['id']);
            }
        }
        return this.slist;
    }
    getYoyakuStatusList(){
        this.ylist = [];
        for (let i = 0; i < this.yoyaku_status_list.length; i++) {
            if(this.yoyaku_status_list[i]['selected']){
                this.ylist.push(this.yoyaku_status_list[i]['id']);
            }
        }
        return this.ylist;
    }
    searchCompany():void{
        let param ={
            eid : this.selected_event_id,
            cid : this.selected_company_id,
            slist : this.getAnswerStatusList(),
            ylist : this.getYoyakuStatusList()
        };
        this.mailService.getCompanyList(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                if (res["fuel_results"]['company'].length==0){
                    this.commonService.modalOpens(11006,modalresult=>{});
                }else{
                    this.send_list_company = res["fuel_results"]['company'];
                }
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    searchSyozoku():void{
        this.syozoku_list =[];
        let param ={
            eid : this.selected_event_id,
            cid : this.selected_company_id,
            search_text:this.syozoku_search_text,
            slist : this.getAnswerStatusList(),
            ylist : this.getYoyakuStatusList()
        };
        this.mailService.getSyozokuList(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                if (res["fuel_results"]['syozoku'].length==0){
                    this.commonService.modalOpens(11006,modalresult=>{});
                }else{
                    this.syozoku_list = res["fuel_results"]['syozoku'];
                }
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    searchPerson():void{    
        this.person_list =[];    
        let param ={
            eid : this.selected_event_id,
            cid : this.selected_company_id,
            search_text:this.person_search_text
        };
        this.mailService.getPersonList(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                if (res["fuel_results"]['person'].length==0){
                    this.commonService.modalOpens(11006,modalresult=>{});
                }else{
                    this.person_list = res["fuel_results"]['person'];
                }
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });


    }

    addPerson(row:any):void{
        this.send_list_person.push(row);
    }
    delPerson(row:any):void{
        this.send_list_person = this.send_list_person.filter(
            item => 
            item.id!=row.id
          );           
    }
    checkPersonList(row){
        var temps = this.send_list_person.filter(
            item => 
            item.id==row.id
          );   
        if (temps.length>0)        {
            return true;
        }else{
            return false;
        }
    }
    addSyozoku(row:any):void{
        this.send_list_syozoku.push(row);
    }
    delSyozoku(row:any):void{
        this.send_list_syozoku = this.send_list_syozoku.filter(
            item => 
            item.t_syozoku_id!=row.t_syozoku_id
          );           
    }
    checkSyozokuList(row){
        var temps = this.send_list_syozoku.filter(
            item => 
            item.t_syozoku_id==row.t_syozoku_id
          );   
        if (temps.length>0)        {
            return true;
        }else{
            return false;
        }
    }

    public beforeChange($event: NgbTabChangeEvent) {
        this.tabActiveId = $event.nextId;
        if (this.send_list_person.length>0 || this.send_list_syozoku.length>0 || this.send_list_company.length>0) {
            this.commonService.modalOpens(50008,
                //選択されている送信リストは破棄されます。よろしいですか？
                modalresult => {
                    if (modalresult == "OK"){
                        this.clearSendArea();
                    }else{
                        $event.preventDefault();
                        this.tabActiveId = $event.activeId;
                    }
                }
            );
        }
      };

    yoyakuhyoCheck():boolean{
        //置換文字に予約表IDをつける
        if (this.mail_content.m_event_task_type_id==21||
            this.mail_content.m_event_task_type_id==22||
            this.mail_content.m_event_task_type_id==23||
            this.yoyakuhyoList.length<2){
            return false;
        }else{
            return true;
        }
    }
    canselmailCheck():boolean{
        if (this.mail_content.m_event_task_type_id==23){
            return false;
        }else{
            return true;
        }
    }
    automailCheck():boolean{
        //自動送信用置換文字
        if (this.mail_content.m_event_task_type_id==21||
            this.mail_content.m_event_task_type_id==22||
            this.mail_content.m_event_task_type_id==23){
            return false;
        }else{
          return true;
        }  
    }


    onChangeTemplate(){
        var row = this.template.filter(
            item => 
            item.id==this.mail_content.m_mail_template_id
            );  
        if (row.length>0){
            this.mail_content.m_mail_template_name=row[0].name;
            this.mail_content.mail_subject=row[0].subject;
            this.mail_content.mail_body=row[0].body;
            this.mail_content.update_datetime=row[0].update_datetime;
            this.mail_content.m_event_task_type_id=row[0].m_event_task_type_id;
        }else{
            this.clearMailContents();
        }
    }

    save() : void {
        const modalRef = this.modalService.open(
            ATemplateSaveModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false }//オプション設定　Esc,背景クリックの時の処理…停止中
        );
        modalRef.componentInstance.template_name = this.mail_content.m_mail_template_name;
        modalRef.componentInstance.m_event_task_type_id = this.mail_content.m_event_task_type_id;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    //OK時の処理
                    if (result.save_command==9){
                        let param={
                            'id' :this.mail_content.m_mail_template_id,
                            'update_datetime':this.mail_content.update_datetime
                        };
                        this.mailService.delete(param)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002,modalresult=>{
                                    //テンプレートのみ入替
                                    this.mailService.templateReload()
                                    .subscribe((res: Response) => {
                                        if (res["fuel_status"] == "OK") {
                                            //テンプレートのみ入替
                                            this.clearMailContents();
                                            this.template= res["fuel_results"]['template'];
                                        }else if (res["fuel_status"] == "NG") {
                                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                                        }else{
                                            this.commonService.modalOpens(11003,modalresult=>{});
                                        }
                                    },error => {
                                        this.commonService.modalOpens(error,modalresult=>{});
                                    });
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                    }else{
                        let param={
                            'id' :result.save_command==1?null:this.mail_content.m_mail_template_id,
                            'name' : result.template_name,
                            'subject' : this.mail_content.mail_subject,
                            'body' :this.mail_content.mail_body,
                            'update_datetime':this.mail_content.update_datetime
                        };
                        this.mailService.save(param)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10001,modalresult=>{
                                    var returnid = res["fuel_results"]["id"];
                                    //テンプレートのみ入替
                                    this.mailService.templateReload()
                                    .subscribe((res: Response) => {
                                        if (res["fuel_status"] == "OK") {
                                            //テンプレートのみ入替
                                            // this.clearMailContents();
                                            this.template= res["fuel_results"]['template'];
                                            this.mail_content.m_mail_template_id = returnid;
                                            this.onChangeTemplate();
                                        }else if (res["fuel_status"] == "NG") {
                                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                                        }else{
                                            this.commonService.modalOpens(11003,modalresult=>{});
                                        }
                                    },error => {
                                        this.commonService.modalOpens(error,modalresult=>{});
                                    });
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                    }
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
    }

    mailcontentsOpen(row:any) : void {
        const modalRef = this.modalService.open(
            AViewTextModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
        );
        modalRef.componentInstance.view_title = row.mail_subject;
        modalRef.componentInstance.view_text = row.mail_body;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
    }
    sendlistOpen(row:any) : void {
        this.mailService.getSendPerson(row.id)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                let sendPersonList = [];
                sendPersonList = res["fuel_results"];
        const modalRef = this.modalService.open(
            AViewTextModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
        );

        let sendlisttext :string = "";
        modalRef.componentInstance.view_title = row.mail_subject;
        if(this.historyMode != 1){
            if (row.sendlist[0]["send_mode"]=="person"){
                        sendlisttext = "全"+sendPersonList.length + "件送信<br>";
                        for (let i = 0; i < sendPersonList.length; i++) {
                            sendlisttext += sendPersonList[i]['person_company_name']+"："+sendPersonList[i]['t_person_name'];
                            if (sendPersonList[i]['resulted'] == "1"){
                        sendlisttext += "<span class='badge badge-danger'>送信失敗</span>";
                    }
                            sendlisttext += " < " + sendPersonList[i]['t_send_mail_distination_mail'] + " > " + "<br>";
                }
            }else if (row.sendlist[0]["send_mode"]=="syozoku"){
                        sendlisttext = "全"+sendPersonList.length + "件送信<br>";
                        for (let i = 0; i < sendPersonList.length; i++) {
                            sendlisttext += sendPersonList[i]['person_company_name']+"："+sendPersonList[i]['t_syozoku_name']+"："+sendPersonList[i]['t_person_name'];
                            if (sendPersonList[i]['resulted'] == "1"){
                        sendlisttext += "<span class='badge badge-danger'>送信失敗</span>";
                    }
                            sendlisttext += " < " + sendPersonList[i]['t_send_mail_distination_mail'] + " > " + "<br>";
                }
            }else if (row.sendlist[0]["send_mode"]=="company"){
                        sendlisttext = "全"+sendPersonList.length + "件送信<br>";
                        for (let i = 0; i < sendPersonList.length; i++) {
                            sendlisttext += sendPersonList[i]['person_company_name']+"："+sendPersonList[i]['t_person_name'];
                            if (sendPersonList[i]['resulted'] == "1"){
                        sendlisttext += "<span class='badge badge-danger'>送信失敗</span>";
                    }
                            sendlisttext += " < " + sendPersonList[i]['t_send_mail_distination_mail'] + " > " + "<br>";
                }
            }
        }else{
                    sendlisttext = "全"+sendPersonList.length + "件送信<br>";
                    for (let i = 0; i < sendPersonList.length; i++) {
                        sendlisttext += sendPersonList[i]['person_company_name']+"："+sendPersonList[i]['t_person_name'];
                        sendlisttext += " < " + sendPersonList[i]['t_send_mail_distination_mail'] + " > " + "<br>";
            }
        }

        modalRef.componentInstance.view_text = sendlisttext;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }

    send(){
    this.commonService.modalOpens(50010,
        //メールを送信してもよろしいですか？
        modalresult => {
            if (modalresult == "OK"){
                /*■■　パラメータ設定　■■*/
                let param={
                    mail_content:this.mail_content,
                    mode:this.tabActiveId,
                    t_event_id:this.selected_event_id,
                    t_company_id:this.selected_company_id,
                    slist:this.tabActiveId=="person" || this.monsin_flg==0 ? []:this.slist,
                    ylist:this.tabActiveId=="person" || this.yoyaku_flg==0 ? []:this.ylist,
                    send_list:this.tabActiveId=="person" ? this.send_list_person:this.tabActiveId=="syozoku" ? this.send_list_syozoku:this.send_list_company,
                    mail_from:this.mail_from,
                    mail_file:this.send_mail_file
                };
                this.mailService.send(param)
                .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        this.commonService.modalOpens(10005,modalresult=>{
                            //送信画面をクリアして閉じる
                            this.clearSendArea();
                            this.tabActiveId = "company";
                            this.clearMailContents();
                            this.mail_open = false;
                            this.page = 1;
                            //履歴のみ入替
                            let paramhist ={
                                eid:this.selected_event_id,
                                page:this.page,
                                display_per_page:this.display_per_page
                            };
                            this.mailService.historyReload(paramhist)
                            .subscribe((res: Response) => {
                                if (res["fuel_status"] == "OK") {
                                    //履歴のみ入替
                                    this.all_count = res["fuel_results"]["all_count"];
                                    this.all_datalist[0] = res["fuel_results"]["history"];
                                    //タスク用の履歴
                                    this.all_datalist[1] = res["fuel_results"]['history_task'];
                                    this.changePage(1);                    
                                }else if (res["fuel_status"] == "NG") {
                                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                                }else{
                                    this.commonService.modalOpens(11003,modalresult=>{});
                                }
                            }
                            ),error => {
                                this.commonService.modalOpens(error,modalresult=>{});
                            };
                        });
                    }else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{
                            this.page = 1;
                            //履歴のみ入替
                            let paramhist ={
                                eid:this.selected_event_id,
                                page:this.page,
                                display_per_page:this.display_per_page
                            };
                            this.mailService.historyReload(paramhist)
                            .subscribe((res: Response) => {
                                if (res["fuel_status"] == "OK") {
                                    //履歴のみ入替
                                    this.all_count = res["fuel_results"]["all_count"];
                                    this.all_datalist[0] = res["fuel_results"]["history"];
                                    //タスク用の履歴
                                    this.all_datalist[1] = res["fuel_results"]['history_task'];
                                    this.changePage(1);    
                                }else if (res["fuel_status"] == "NG") {
                                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                                }else{
                                    this.commonService.modalOpens(11003,modalresult=>{});
                                }
                            }
                            ),error => {
                                this.commonService.modalOpens(error,modalresult=>{});
                            };
                        });
                    }else{
                        this.commonService.modalOpens(11003,modalresult=>{});
                    }
                },error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                });
            
            }else{
            //
            }
        }
    );
    }
    upload(list: any): void {
        if(list.length>0){
            let f = list[0];
            // ファイルをセット
            let data = new FormData();
            data.append('upfile', f, f.name);
            // サーバーに送信
            this.mailService.uploadFile(data)
            .subscribe((res: Response) =>{
                    if (res["fuel_status"] == "OK") {
                        // 取得された添付ファイルの情報
                        let param={
                            id:res["fuel_results"]['id'],
                            file_path:res["fuel_results"]['file_path'],
                            file_name:res["fuel_results"]['file_name'],
                            file_size:res["fuel_results"]['file_size'],
                            file_size_before:res["fuel_results"]['file_size_before']
                        }
                        // ファイル情報を配列に追加する
                        this.file_size_before = 0;
                        this.file_size_after = 0;
                        this.send_mail_file.push(param);
                        for (let i=0; i < this.send_mail_file.length; i++){
                            this.file_size_before = this.file_size_before + this.send_mail_file[i]['file_size_before'];
                        }
                        this.can_send_file();
                    }
                },error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                }
            );
        }else{
            //
        }
    }
    file_del(list: any,index: number): void {
        //添付しているファイルを破棄してもよろしいですか？
        this.commonService.modalOpens(50016,
            modalresult => {
                if (modalresult == "OK"){
                    // 添付されているファイルの削除
                    this.mailService.deleteFile(list)
                    .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                            // 添付ファイルをリストから削除
                            this.send_mail_file = this.send_mail_file.filter(
                                item => 
                                item.id!=list.id
                            );  
                            this.file_size_before = this.file_size_before - list['file_size_before'];
                            this.can_send_file();
                        }else if (res["fuel_status"] == "NG") {
                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                        }else{
                            this.commonService.modalOpens(11003,modalresult=>{});
                        }
                    });
                }else{
                    //
                }
            }
        );
    }
    goBack(): void {
        this.location.back();
    }
    can_search_mon():boolean{
        if(this.monsin_flg == 1){
            var row = this.status_list.filter(
                item => 
                item.selected==true
                );  
            if (row.length>0){
                return false;
            }else{
                return true;
            }
        } else {
            return false;
        }
    }
    can_search_yoyaku():boolean{
        if(this.yoyaku_flg == 1){
            var row = this.yoyaku_status_list.filter(
                item => 
                item.selected==true
                );  
            if (row.length>0){
                return false;
            }else{
                return true;
            }
        } else {
            return false;
        }
    }
    can_send():boolean{
        switch (this.tabActiveId){
            case "company":
            return true;
            // var row = this.status_list.filter(
            //     item => 
            //     item.selected==true
            //     );  
            // if (row.length>0){
            //     if (this.send_list_company.length>0){
            //         return true;
            //     }else{
            //         return false;
            //     }
            // }else{
            //     return false;
            // }
        case "syozoku":
            var row = this.status_list.filter(
                item => 
                item.selected==true
                );  
            if (row.length>0){
                if (this.send_list_syozoku.length>0){
                    return true;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        
        case "person":
            if (this.send_list_person.length>0){
                return true;
            }
        default:
            return false;
          }               
    }
    can_send_file():boolean{
        // ファイルサイズの変換
        const kb = 1024
        const mb = Math.pow(kb, 2);
        const gb = Math.pow(kb, 3);
        const tb = Math.pow(kb, 4);

        let target = null;
        let unit = 'byte';
        
        if (this.file_size_before >= tb) {
            target = tb;
            unit = 'TB';
        } else if (this.file_size_before >= gb) {
            target = mb;
            unit = 'MB';
        } else if (this.file_size_before >= mb) {
            target = mb;
            unit = 'MB';
        } else if (this.file_size_before >= kb) {
            target = kb;
            unit = 'KB';
        }
        this.file_size_after = target !== null ? Math.floor((this.file_size_before / target) * 100) / 100 : this.file_size_before;
        // 単位を付けて出力
        this.sum_file_size = this.file_size_after + unit;
        if(this.file_size_before > 5242880){
            return this.over_size = true;
        }else{
            return this.over_size = false;
        }    
    }
    select_history_mode(i:number){
        this.historyMode=i;
        this.all_count = this.all_datalist[this.historyMode].length;
        this.page = 1;
        this.changePage(1);
    }
    goMailTaskCreate(): void {
        const modalRef = this.modalService.open(
          MailTaskCreateComponent, //対象のComponent
          { backdrop: "static", keyboard: false, size: "lg" } //オプション設定　Esc,背景クリックの時の処理…停止中
        );
        modalRef.componentInstance.eventId = this.selected_event_id;
        modalRef.componentInstance.mailTemplate = this.mail_content;
        modalRef.componentInstance.taskType = this.taskType;
        modalRef.componentInstance.sendFiles = this.send_mail_file;
        if(this.send_list_company.length>0){
            modalRef.componentInstance.sendPersons = this.send_list_company;
        }else if(this.send_list_syozoku.length>0){
            var list = [];
            var count = 0;
            for(let i = 0; this.send_list_syozoku.length>i; i++){
                for(let j = 0; this.send_list_syozoku[i].enable_list.length > j; j++){
                    list[count] = this.send_list_syozoku[i].enable_list[j];
                    count++;
                }
            }
            modalRef.componentInstance.sendPersons = list;
        }else if(this.send_list_person.length>0){
            modalRef.componentInstance.sendPersons = this.send_list_person;
        }else{
            modalRef.componentInstance.sendPersons = [];
        }
        modalRef.result.then(
          (result) => {
            if (result.status == "OK") {
                //送信画面をクリアして閉じる
                this.clearSendArea();
                this.tabActiveId = "company";
                this.clearMailContents();
                this.mail_open = false;
                this.page = 1;
                //履歴のみ入替
                let paramhist ={
                    eid:this.selected_event_id,
                    page:this.page,
                    display_per_page:this.display_per_page
                };
                this.mailService.historyReload(paramhist)
                .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        //履歴のみ入替
                        this.all_count = res["fuel_results"]["all_count"];
                        this.all_datalist[0] = res["fuel_results"]["history"];
                        //タスク用の履歴
                        this.all_datalist[1] = res["fuel_results"]['history_task'];
                        this.changePage(1);                    
                    }else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                    }else{
                        this.commonService.modalOpens(11003,modalresult=>{});
                    }
                }
                ),error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                };
            //   this.TargetDayOfTheWeek = result.selectedData;
            //   this.clearTargetDayOfTheWeek();
            } else {
              //
            }
        },
        function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
        }
        );
    }
    deleteTask(row:any):void {
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.mailService.deleteTask(row)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002, modalresult => {
                                //送信画面をクリアして閉じる
                                this.clearSendArea();
                                this.tabActiveId = "company";
                                this.clearMailContents();
                                this.mail_open = false;
                                this.page = 1;
                                //履歴のみ入替
                                let paramhist ={
                                    eid:this.selected_event_id,
                                    page:this.page,
                                    display_per_page:this.display_per_page
                                };
                                this.mailService.historyReload(paramhist)
                                .subscribe((res: Response) => {
                                    if (res["fuel_status"] == "OK") {
                                        //履歴のみ入替
                                        this.all_count = res["fuel_results"]["all_count"];
                                        this.all_datalist[0] = res["fuel_results"]["history"];
                                        //タスク用の履歴
                                        this.all_datalist[1] = res["fuel_results"]['history_task'];
                                        this.changePage(1);                    
                                    }else if (res["fuel_status"] == "NG") {
                                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                                    }else{
                                        this.commonService.modalOpens(11003,modalresult=>{});
                                    }
                                }
                                ),error => {
                                    this.commonService.modalOpens(error,modalresult=>{});
                                };
                                });
                            } else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                            } else {
                                this.commonService.modalOpens(11003, modalresult => { });
                            }
                        }, error => {
                            this.commonService.modalOpens(error, modalresult => { });
                        });
                } else {
                    //
                }
            }
        );    
    }
    showMailTaskSetting(row:any) : void {
        // タスク情報を取得
        this.mailService.getTaskSetting(row.t_event_task_id)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                // 添付ファイルをリストから削除
                const modalRef = this.modalService.open(
                    ATaskShowModalComponent,//対象のComponent
                    { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
                );
                modalRef.componentInstance.taskSetting = res["fuel_results"];
                modalRef.result.then(
                    result => {
                        if(result.status=='Cancel'){
                            //Cancel時の処理
                        }else{
                            
                        }
                    }, function () {
                    // Esc,背景クリックの時の処理…オプション設定で停止中
                    }
                );
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        });

    }
}


// WEBPACK FOOTER //
// ./src/app/a0106-mail/mail.component.ts